export const AUTOMATION_BUILD_LOGS = "AUTOMATION_BUILD_LOGS";
export const AUTOMATION_BUILD_LOG = "AUTOMATION_BUILD_LOG";